import { useMemo } from 'react';

import { Job } from 'src/types/gojob';

const mapLevelToNumber = (level: Required<Job>['languageSkills'][0]['level']) => {
  switch (level) {
    case 'BEGINNER':
      return 0 as const;
    case 'ACADEMIC':
      return 1 as const;
    case 'PROFESSIONAL':
      return 2 as const;
    case 'BILINGUAL':
      return 3 as const;
    default:
      return undefined;
  }
};

const useLanguageSkills = (job?: Job) => {
  return useMemo(() => {
    return (job?.languageSkills || []).map((skill) => {
      return { language: { value: skill?.caption }, level: mapLevelToNumber(skill?.level) };
    });
  }, [job?.languageSkills]);
};

export default useLanguageSkills;
